var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5C13 13.2783 10.3137 10.6667 7 10.6667C3.68629 10.6667 1 13.2783 1 16.5M7 8.16667C5.10645 8.16667 3.57143 6.67428 3.57143 4.83333C3.57143 2.99238 5.10645 1.5 7 1.5C8.89355 1.5 10.4286 2.99238 10.4286 4.83333C10.4286 6.67428 8.89355 8.16667 7 8.16667Z",
    stroke: "#202124",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlack);
export default __webpack_public_path__ + "static/media/User-Black.61910aae2ae0769ce736b222bcfe1979.svg";
export { ForwardRef as ReactComponent };